<template>
  <div class="generator">
    <header>
      <el-button type="text" @click="$router.push({ name: 'index' })">进入管理端</el-button>
      <div class="user-info">
        <span>欢迎你，</span>
        <span>{{userInfo | displayName}}</span>
        <img v-if="userInfo != null" :src="userInfo.avatar == null ? '@/assets/images/avatar/man.png' : userInfo.avatar" alt="">
      </div>
    </header>
    <div class="wrap">
      <main>
        <div class="search-box">
          <h1>全智代码</h1>
          <div class="input-wrap">
            <input v-model="form.keywords" type="text" placeholder="输入关键词，如电子商务系统" @input="handleKeywordInput">
            <button @click="matchIndustry()" :disabled="!generatable || $route.query.name != null">立即生成</button>
          </div>
        </div>
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="系统类型" prop="templateId">
            <TemplateSelect ref="templateSelect" v-model="form.templateId" placeholder="请选择系统类型"/>
          </el-form-item>
          <el-form-item label="系统名称" prop="systemName" required>
            <el-input v-model="form.systemName" placeholder="如：全智教务系统" maxlength="16" @input="handleNameInput"/>
          </el-form-item>
          <el-form-item label="系统英文名称" prop="systemEnName" required>
            <el-input v-model="form.systemEnName" placeholder="如：quanzhi" maxlength="20"/>
          </el-form-item>
          <el-form-item label="系统LOGO">
            <div slot="label" class="switch-label">
              <label>系统LOGO</label>
              <a href="javascript:;" @click="switchImageType('logo')">{{ imageTypeData.logo | switchButtonText }}</a>
            </div>
            <ImageUploader v-if="imageTypeData.logo === 'upload'" :preview-url="form.systemLogo" :upload-success="uploadLogoSuccess"/>
            <NetworkImageInput v-else v-model="form.systemLogo"/>
          </el-form-item>
          <el-form-item label="系统登录页大图">
            <div slot="label" class="switch-label">
              <label>系统登录页大图</label>
              <a href="javascript:;" @click="switchImageType('loginImage')">{{ imageTypeData.loginImage | switchButtonText }}</a>
            </div>
            <ImageUploader v-if="imageTypeData.loginImage === 'upload'" :preview-url="form.systemLoginImage" :upload-success="uploadLoginImageSuccess"/>
            <NetworkImageInput v-else v-model="form.systemLoginImage"/>
          </el-form-item>
        </el-form>
      </main>
      <div class="config-wrap" :class="{ hidden: !visibleConfig }">
        <div class="startup-wrap">
          <span @click="visibleConfig = !visibleConfig">
            <i v-show="visibleConfig" class="el-icon-s-unfold"></i>
            <i v-show="!visibleConfig" class="el-icon-s-fold"></i>
          </span>
        </div>
        <div class="content-wrap">
          <h4>参数设置</h4>
          <Runner
            v-if="!loading"
            ref="runner"
            :data="form"
            :record-id="record.id"
            :parameter="record.parameter"
            :outside-check="outsideCheck"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Runner from '@/components/common/runner/Runner'
import ImageUploader from '../components/common/ImageUploader'
import NetworkImageInput from '../components/common/NetworkImageInput'
import TemplateSelect from '@/components/template/TemplateSelect'
import { pinyin } from 'pinyin-pro'
import { matchIndustry, matchTemplate } from '@/api/runner/runner'
import { fetchById } from "@/api/generate/list";

export default {
  components: { TemplateSelect, NetworkImageInput, ImageUploader, Runner },
  data () {
    const _this = this
    return {
      loading: true,
      // 编辑时将填充该数据
      record: {
        id: null,
        parameter: null
      },
      visibleConfig: false,
      forceTemplate: false,
      form: {
        templateId: null,
        industryId: null,
        keywords: '',
        systemName: '',
        systemEnName: '',
        systemLogo: '',
        systemLoginImage: '',
        industryKeywords: '',
        matchKeywords: ''
      },
      // 图片类型切换数据
      imageTypeData: {
        logo: 'upload',
        loginImage: 'upload'
      },
      rules: {
        systemName: [
          { required: true, message: '请输入系统名称' }
        ],
        systemEnName: [
          { required: true, message: '请输入系统英文名称' },
          { validator: _this.checkEnName }
        ]
      }
    }
  },
  computed: {
    ...mapState(['userInfo']),
    generatable () {
      return this.form.systemName.trim().length > 0 && this.form.systemEnName.trim().length > 0
    }
  },
  filters: {
    // 图片类型切换按钮文案
    switchButtonText (value) {
      if (value === 'upload') {
        return '使用网络路径'
      }
      if (value === 'network') {
        return '手动上传'
      }
      return ''
    },
    // 展示名称
    displayName (userInfo) {
      if (userInfo == null) {
        return ''
      }
      if (userInfo.realname != null && userInfo.realname.trim().length > 0) {
        return userInfo.realname
      }
      return userInfo.username
    }
  },
  methods: {
    // 查询记录详情
    fetchById () {
      this.loading = true
      fetchById(this.record.id)
        .then(data => {
          const parameter = JSON.parse(data.parameter)
          this.record.parameter = parameter
          this.form.systemName = data.systemName
          this.form.systemEnName = data.systemEnName
          this.form.templateId = parameter.templateId || 1
          this.form.industryId = parameter.industryId
          this.form.systemLoginImage = parameter.systemLoginImage
          this.form.systemLogo = parameter.systemLogo
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleKeywordInput (e) {
      this.form.systemName = e.target.value
      this.form.systemEnName = pinyin(e.target.value, { toneType: 'none', type: 'array' }).map(item => item.substr(0, 1)).join('')
    },
    handleNameInput (value) {
      this.form.systemEnName = pinyin(value, { toneType: 'none', type: 'array' }).map(item => item.substr(0, 1)).join('')
    },
    // 切换图片类型
    switchImageType (dataKey) {
      if (dataKey === 'logo') {
        this.form.systemLogo = ''
      }
      if (dataKey === 'loginImage') {
        this.form.systemLoginImage = ''
      }
      if (this.imageTypeData[dataKey] === 'upload') {
        this.imageTypeData[dataKey] = 'network'
      } else {
        this.imageTypeData[dataKey] = 'upload'
      }
    },
    // 匹配行业
    matchIndustry (force = false) {
      if (!this.generatable) {
        return
      }
      this.$refs.form.validate((pass) => {
        if (!pass && force === false) {
          return
        }
        matchTemplate(this.form.keywords)
          .then((data) => {
            if (data == null && force === false) {
              throw new Error('没有匹配到相关模版，请更换关键字后重试')
            }
            // 未匹配到模版，随机选中一个
            if (data == null) {
              this.form.templateId = this.$refs.templateSelect.random()
              this.forceTemplate = false
            } else {
              this.form.templateId = data.id
              this.forceTemplate = true
            }
            if (force === false) {
              return matchIndustry(this.form.keywords)
            }
            // 强制模式下（从智能录入跳转过来，携带了行业ID，此时不需要进行匹配）
            return null
          })
          .then(data => {
            // 只有在非强制模式下才做提醒
            if (data == null && force === false) {
              this.$tip.warning('没有匹配到相关行业，请更换关键字后重试')
              return
            }
            // 只有在从智能录入过来时force才为true，此时打开设置窗口即可
            if (force === true) {
              this.visibleConfig = true
              return
            }
            this.form.industryKeywords = data.keywords
            this.visibleConfig = true
            this.$refs.runner.random(data)
          })
          .catch(e => {
            this.$tip.apiFailed(e)
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    // 上传系统LOGO
    uploadLogoSuccess (response) {
      if (!response.success) {
        this.$tip.error(response)
        return
      }
      this.form.systemLogo = response.data.accessUri
    },
    // 上传系统登录大图
    uploadLoginImageSuccess (response) {
      if (!response.success) {
        this.$tip.error(response)
        return
      }
      this.form.systemLoginImage = response.data.accessUri
    },
    // 验证项目英文名称
    checkEnName (rule, value, callback) {
      if (!/^[a-z]+$/.test(value)) {
        callback(new Error('英文名称必须为小写字母'))
        return
      }
      callback()
    },
    // runner外部检测
    outsideCheck () {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((pass) => {
          if (pass) {
            resolve()
            return
          }
          reject()
        })
      })
    }
  },
  created () {
    // 存在ID（修改已有记录信息）
    if (this.$route.query.id != null) {
      this.record.id = this.$route.query.id
      this.visibleConfig = true
      this.fetchById()
      return
    }
    // 存在名称，则自动填充名称并匹配模版和行业
    if (this.$route.query.name != null) {
      // 填充项目基础信息
      this.form.keywords = this.$route.query.name
      this.form.systemName = this.$route.query.name
      let systemLogo = null
      if (this.$route.query.logo_file_key != null && this.$route.query.logo_file_key !== '') {
        systemLogo = `/resource/image?f=${this.$route.query.logo_file_key}`
      }
      this.form.systemLogo = systemLogo
      this.form.systemEnName = pinyin(this.form.systemName, {
        toneType: 'none',
        type: 'array'
      }).map(item => item.charAt(0)).join('')
      this.$nextTick(() => {
        this.matchIndustry(true)
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/style/variables";
.generator {
  height: 100vh;
  font-family: Arial,sans-serif;
  display: flex;
  flex-direction: column;
  background-color: #f7f7f7;
  overflow-y: auto;
  header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 15px 40px;
    flex-shrink: 0;
    .el-button {
      margin-right: 10px;
      padding: 0;
      position: relative;
      top: 1px;
      color: $font-color;
      &:hover {
        text-decoration: underline;
      }
    }
    .user-info {
      display: flex;
      align-items: center;
      img {
        width: 20px;
        margin-left: 5px;
      }
      span {
        font-size: 12px;
      }
    }
  }
  .wrap {
    flex-grow: 1;
    overflow: hidden;
    padding-top: 20px;
    display: flex;
  }
  main {
    width: 750px;
    margin: 0 auto;
    padding: 60px 60px;
    box-sizing: border-box;
    background-color: #fff;
    overflow-y: auto;
    .search-box {
      h1 {
        text-align: center;
        font-size: 40px;
      }
      .input-wrap {
        width: 100%;
        margin: 40px auto 0 auto;
        display: flex;
        input {
          flex-grow: 1;
          border: 2px solid #ccc;
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
          border-right: 0;
          box-sizing: border-box;
          padding: 0 15px;
          font-size: 16px;
          outline: none;
          transition: all ease .3s;
          &:focus {
            border-color: $primary-color;
          }
        }
        button {
          flex-shrink: 0;
          width: 100px;
          height: 45px;
          background-color: $primary-color;
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
          color: #fff;
          border: 0;
          font-size: 16px;
          &[disabled] {
            background-color: #999;
            cursor: not-allowed;
          }
        }
      }
    }
    .el-form {
      overflow-y: auto;
      margin-top: 40px;
      .el-form-item {
        display: flex;
        flex-direction: column;
        /deep/ .el-form-item__label {
          text-align: left;
          .switch-label {
            display: flex;
            justify-content: space-between;
          }
        }
      }
      /deep/ .el-input {
        .el-input__inner {
          height: 40px;
          font-size: 16px;
          border: 0;
          border-bottom: 1px solid #ccc;
          padding: 0;
          &:focus {
            border-color: $primary-color;
          }
        }
      }
    }
  }
  .config-wrap {
    margin-left: 10px;
    width: 50%;
    min-width: 800px;
    height: 100%;
    display: flex;
    transition: all ease-out .15s;
    overflow-x: hidden;
    overflow-y: auto;
    &.hidden {
      width: 25px;
      min-width: 0;
    }
    .startup-wrap {
      flex-shrink: 0;
      width: 25px;
      height: 100%;
      display: flex;
      justify-content: center;
      span {
        width: 25px;
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $primary-color;
        color: #fff;
        cursor: pointer;
      }
    }
    .content-wrap {
      flex-grow: 1;
      height: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      h4 {
        flex-shrink: 0;
        padding: 10px 10px;
        font-weight: normal;
        border-bottom: 1px solid #e0e0e0;
      }
    }
  }
}
</style>
